import i18next from 'i18next';

i18next.addResources('en', 'MaturationPeatedCasks', {
  peated: 'PEATED CASKS:',
  unpeated: 'UNPEATED CASKS:'
});
